import React, { Component } from "react";
import styles from "./style.module.css";

export default (ChartComponent) =>
  class ResponsiveChart extends Component {
    constructor(props) {
      super(props);

      this.state = {
        containerWidth: null,
        containerHeight: null
      };

      this.fitParentContainer = this.fitParentContainer.bind(this);
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.isFeatures !== nextProps.isFeatures) {
        setTimeout(() => this.fitParentContainer(), 20);
      }
    }

    componentDidMount() {
      this.fitParentContainer();
      window.addEventListener("resize", this.fitParentContainer);
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.fitParentContainer);
    }

    fitParentContainer() {
      const { containerWidth, containerHeight } = this.state;
      const currentContainerWidth = this.chartContainer.getBoundingClientRect().width;
      const currentContainerHeight = this.chartContainer.getBoundingClientRect().height;

      const shouldResize = containerWidth !== currentContainerWidth || containerHeight !== currentContainerHeight;

      if (shouldResize) {
        this.setState({
          containerWidth: currentContainerWidth,
          containerHeight: currentContainerHeight
        });
      }
    }

    renderChart() {
      const { containerWidth, containerHeight } = this.state;

      return <ChartComponent {...this.props} parentWidth={containerWidth} parentHeight={containerHeight} />;
    }

    render() {
      const { containerWidth, containerHeight } = this.state;
      const shouldRenderChart = containerWidth !== null && containerHeight !== null && containerWidth !== 0;

      return (
        <div
          ref={(el) => {
            this.chartContainer = el;
          }}
          className={styles.rChart}
        >
          {shouldRenderChart && this.renderChart()}
        </div>
      );
    }
  };
